module.exports = __webpack_public_path__ + "img/0003.31520fab.png";